import { render, staticRenderFns } from "./ListExpenses.vue?vue&type=template&id=50ba4357&"
import script from "./ListExpenses.vue?vue&type=script&lang=js&"
export * from "./ListExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports